import { KeyValue, KeyValueDefault } from "@/main/models/common";
import { QuoteDirectAssignItemsResponse } from "@/main/models/response";
import { isNullUndefined } from "@/main/services/reducerUtils";
import { getTranslateByKey } from "@/main/services/utils";
import { formatCurrency } from "@/main/services/utilsNumber";
import { renderStrings } from "@/main/services/utilsString";
import { isNil } from "lodash";

export interface PartBuyerManualAnswerForm {
	guidQuoteItem: string;
	supplier: KeyValue | null;
	partType: KeyValueDefault | null;
	price: string;
	deadline: number | null;
}

export interface BuyerPartForms {
	parts: PartBuyerManualAnswerForm[];
	reason: KeyValueDefault | null;
	reasonComplement: string;
}

export interface AutoFillForms {
	supplier: KeyValue | null;
	partType: KeyValueDefault | null;
	deadline: number | null;
}

export const INITIAL_FORM_STATE: BuyerPartForms = {
	parts: [],
	reason: null,
	reasonComplement: "",
};

export const INITIAL_FORM_STATE_AUTOFILL: AutoFillForms = {
	deadline: null,
	partType: null,
	supplier: null,
};

export function renderPrices({
	priceCap,
	price,
	systemReferencePrice,
	systemReferencePriceFormatted,
}: QuoteDirectAssignItemsResponse) {
	const priceCapFormatted = formatCurrency(priceCap);
	const priceFormatted = !isNil(price) ? formatCurrency(price) : null;

	const referencePrice = isNullUndefined(systemReferencePrice)
		? priceCapFormatted
		: `${getTranslateByKey("information.systemReferencePrice")}: ${systemReferencePriceFormatted}`;

	return renderStrings([referencePrice, priceFormatted], " / ");
}
